import script from "./CreateSolutionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSolutionSection.vue?vue&type=script&setup=true&lang=js"

import "./CreateSolutionSection.vue?vue&type=style&index=0&id=05785d2f&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05785d2f"]])

export default __exports__